import cx from "classnames";
import Markdown from "./Markdown";

const TooltipContent = ({
  className,
  markdown,
  style
}: {
  className?: string;
  markdown: string;
  style?: React.CSSProperties;
}) => (
  <div
    data-testid="tooltip-content"
    className={cx(
      "font-normal text-center text-xs leading-5 text-neutral-700",
      className
    )}
    style={style}
  >
    <Markdown text={markdown} />
  </div>
);

export default TooltipContent;
